import { Input, Component, OnInit, EventEmitter, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import {PreviewModeDialogResult} from "@feature/preview-mode";

@Component({
  selector: 'mojo-mci-preview-mode-dialog',
  templateUrl: './mci-preview-mode-dialog.component.html'
})
export class MciPreviewModeDialogComponent implements OnInit {

  @Input() dialogTitle = "Preview";

  @Input() clients: SelectItem[];

  @Input() clientParents: SelectItem[];

  @Input() displayDialog: boolean;

  @Output() onCancel = new EventEmitter();

  @Output() onOk = new EventEmitter<PreviewModeDialogResult>();

  clientOrClientParentOptions = [
    { label: 'Client', value: 'Client' },
    { label: 'Client Parent', value: 'Client Parent' }
  ];

  clientOrClientParent = 'Client';

  dialogForm = new UntypedFormGroup(
    {
      clientOrClientParent: new UntypedFormControl(this.clientOrClientParent),
      selectedClient: new UntypedFormControl(),
      selectedClientParent: new UntypedFormControl()
    },
    this.getRequiredValuesValidator()
  );

  get isClient(): boolean {
    return this.dialogForm ? this.dialogForm.controls['clientOrClientParent'].value === 'Client' : false;
  }

  ngOnInit() {
  }

  okHandler(): void {
    let result: PreviewModeDialogResult;
    if (this.isClient) {
      result = new PreviewModeDialogResult(this.dialogForm.controls['selectedClient'].value.Ref, 'Client');
    } else {
      result = new PreviewModeDialogResult(this.dialogForm.controls['selectedClientParent'].value.Ref, 'Client Parent');
    }
    this.onOk.emit(result);
  }

  cancelHandler(): void {
    this.displayDialog = false;
    this.onCancel.emit();
  }

  getRequiredValuesValidator() {
    return (fg: UntypedFormGroup) => {

      const clientIsNeededAndValid = (fg.controls['clientOrClientParent'].value === 'Client' &&
        fg.controls['selectedClient'].value &&
        fg.controls['selectedClient'].value.Ref);

      const clientParentIsNeededAndValid = (fg.controls['clientOrClientParent'].value === 'Client Parent' &&
        fg.controls['selectedClientParent'].value &&
        fg.controls['selectedClientParent'].value.Ref);

      const result = (clientIsNeededAndValid || clientParentIsNeededAndValid) ? null : { required: true };
      return result;
    }
  }
}
